import AdminProjects from "../../components/admin/admin-projects/AdminProjects";
import AdminTemplate from "../../views/AdminTemplate";

const AdminProjectsPage = () => {
  return (
    <AdminTemplate>
      <AdminProjects />
    </AdminTemplate>
  );
};

export default AdminProjectsPage;
